const polyfillsRequestAnimationFrame: Promise<void>[] = [];

if (!('requestAnimationFrame' in window)) {
    polyfillsRequestAnimationFrame.push(import(/* webpackChunkName: "raf" */ 'raf/polyfill'));
}

export default polyfillsRequestAnimationFrame;
